<template>
    <main class="container-fluid">
        <slot/>
    </main>
</template>

<script>
export default {
    name: 'CleanLayout',
}
</script>

<style scoped>

</style>
